import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MenuService } from '../shared/menu.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AppService, DocumentAction } from '../shared/app.service';
import { pdfDefaultOptions, NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgIf } from '@angular/common';
// https://stackoverflow.com/questions/58382943/display-pdf-file-inside-angular-component-using-ngx-extended-pdf-viewer/58421409#58421409
// "assets": [
//   { "glob": "**/pdf.worker.js", "input": "node_modules/ngx-extended-pdf-viewer/assets", "output": "/assets/" },
//   ...
//   }]

export interface IGenericDocument {
  title: string;
  //content?: Blob;
  src: string;
  //extension:string;
  ispdf: boolean;
  useinline: boolean;
}

@Component({
    selector: 'app-document-viewer',
    templateUrl: './document-viewer.component.html',
    styleUrls: ['./document-viewer.component.scss'],
    standalone: true,
    imports: [NgIf, NgxExtendedPdfViewerModule]
})
export class DocumentViewerComponent {

  _documentdata: IGenericDocument;
  frameurl: any;
  pdfjsurl: any;

  @Output() onclose = new EventEmitter();

  @Input()
  set documentdata(value: IGenericDocument) {

    this.pdfDownloadAllowed = this.menuService.appGlobalData.PdfDownloadAllowed;
    this._documentdata = value;

    // geen pdf document , altijd inline tonen
    if (!value.ispdf) {
      this.useframeinline = true;
      this.usepdfjs = false;
      this.frameurl = this.domSanitizer.bypassSecurityTrustResourceUrl(value.src);
      return;
    }

    this.pdfDownloadFilename = `${this.documentdata.title}.pdf`;

    // toon pdf met pdfjs viewer als het een pdf is en useinline is ingeschakeld
    if (value.useinline) {
      this.useframeinline = false;
      this.pdfjsurl = value.src;
      this.usepdfjs = true;
      return;
    }

    this.usepdfjs = false;
    this.useframeinline = true;
    // brower ondersteund native pdf
    this.frameurl = this.domSanitizer.bypassSecurityTrustResourceUrl(value.src);
  }
  get documentdata() { return this._documentdata; }

  @Input()
  ispdf: boolean;

  usepdfjs = false;
  useframeinline = false;
  pdfDownloadAllowed = false;
  pdfDownloadFilename: string;

  constructor(private menuService: MenuService, private domSanitizer: DomSanitizer, private appService: AppService) {
    pdfDefaultOptions.assetsFolder = 'dist/assets'
  }

  close() {
    this.usepdfjs = false;
    this.menuService.documentViewerVisible = false;
    this.onclose.emit();
  }

}
